var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0894 10.7305V11.4805C16.0894 11.683 15.9319 11.848 15.7219 11.8555H14.6269C14.2294 11.8555 13.8694 11.563 13.8394 11.173C13.8169 10.9405 13.9069 10.723 14.0569 10.573C14.1919 10.4305 14.3794 10.3555 14.5819 10.3555H15.7144C15.9319 10.363 16.0894 10.528 16.0894 10.7305Z",
    fill: "#FCFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4909 10.018C13.1159 10.3855 12.9359 10.933 13.0859 11.503C13.2809 12.2005 13.9634 12.643 14.6834 12.643H15.3359C15.7484 12.643 16.0859 12.9805 16.0859 13.393V13.5355C16.0859 15.088 14.8184 16.3555 13.2659 16.3555H4.65594C3.10344 16.3555 1.83594 15.088 1.83594 13.5355V8.48797C1.83594 7.56547 2.27844 6.74797 2.96094 6.23797C3.43344 5.87797 4.01844 5.66797 4.65594 5.66797H13.2659C14.8184 5.66797 16.0859 6.93547 16.0859 8.48797V8.81797C16.0859 9.23047 15.7484 9.56797 15.3359 9.56797H14.5709C14.1509 9.56797 13.7684 9.73297 13.4909 10.018Z",
    fill: "#FCFAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1513 4.115C12.3538 4.3175 12.1813 4.6325 11.8963 4.6325L6.13626 4.625C5.80626 4.625 5.63376 4.22 5.87376 3.9875L7.08876 2.765C8.11626 1.745 9.78126 1.745 10.8088 2.765L12.1213 4.0925C12.1288 4.1 12.1438 4.1075 12.1513 4.115Z",
    fill: "#FCFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectActive);
export default __webpack_public_path__ + "static/media/project-active.c7ef7d48e419a9547bec8be0c5aae026.svg";
export { ForwardRef as ReactComponent };